export default "__VITE_ASSET__B3B9oAod__"